/* ONECART: Main Category(L2) ホバー → Subcategory(L3) を右にフライアウト表示（デスクトップのみ）。
   L2↔L3 の親子関係は storefront データに無いため、ホバー時に
   「裏コレクション?filter.p.m.onecart.l2_category=<L2>&filter.v.availability=1」を AJAX 取得し、
   返ってきた L3 フィルタ一覧をパネルに描画する（L2 ごとに JS キャッシュ）。
   クリックで、フォーム内の(デスクトップでは非表示の)L2/L3 チェックボックスを check して change を発火
   → コレクションは Dawn facets.js、shop ページは独自AJAX が適用する（URL 構築不要）。 */
(function () {
  if (window.__ocL3FlyoutInit) return;
  window.__ocL3FlyoutInit = true;

  var L2_PARAM = 'filter.p.m.onecart.l2_category';
  var L3_PARAM = 'filter.p.m.onecart.l3_category';
  var L2_SEL = '#FacetsWrapperDesktop details[id^="Details-' + L2_PARAM + '-"] .facets__item';

  var cache = {};
  var flyout = null;
  var hideTimer = null;
  var currentL2 = null;

  function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

  function cssEscapeVal(s) { return String(s).replace(/(["\\])/g, '\\$1'); }
  function attrEscape(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  // 裏コレクションのベースURL（shop ページは anchor の data 属性、コレクションは現在URL）
  function getCollectionBase() {
    var anchor = document.getElementById('shop-products-anchor');
    var url = anchor && anchor.getAttribute('data-shop-collection-url');
    if (url) return url;
    return window.location.pathname + window.location.search;
  }

  function buildPreviewUrl(l2) {
    var raw = getCollectionBase();
    var path = raw.split('?')[0];
    var src = new URLSearchParams(raw.indexOf('?') > -1 ? raw.split('?')[1] : '');
    var np = new URLSearchParams();
    var q = src.get('q'); if (q) np.set('q', q);
    var sb = src.get('sort_by'); if (sb) np.set('sort_by', sb);
    np.set('filter.v.availability', '1');
    np.append(L2_PARAM, l2);
    return path + '?' + np.toString();
  }

  function ensureFlyout() {
    if (flyout) return flyout;
    flyout = document.createElement('div');
    flyout.className = 'oc-l3-flyout';
    flyout.hidden = true;
    flyout.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    flyout.addEventListener('mouseleave', scheduleHide);
    document.body.appendChild(flyout);
    return flyout;
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      if (flyout) { flyout.hidden = true; currentL2 = null; }
    }, 200);
  }

  function positionFlyout(el) {
    var f = ensureFlyout();
    var box = el.closest('details') || el.closest('.facets-fallback') || el.closest('aside') || el;
    var br = box.getBoundingClientRect();
    var lr = el.getBoundingClientRect();
    var fw = f.offsetWidth || 280;
    var left = Math.min(br.right + 8, window.innerWidth - fw - 8);
    f.style.left = Math.round(Math.max(8, left)) + 'px';
    f.style.top = Math.round(Math.min(Math.max(8, lr.top), window.innerHeight - 60)) + 'px';
  }

  // items: フィルタ系は {value,label,count}（クリックでフィルタ適用）、
  //        カテゴリ系は {label,url}（クリックでそのコレクションへ遷移）。
  function renderItems(key, items, asLinks) {
    var f = ensureFlyout();
    if (!asLinks && currentL2 !== key) return;
    if (!items || !items.length) { f.innerHTML = '<div class="oc-l3-flyout__loading">—</div>'; return; }
    var html = '';
    items.forEach(function (it) {
      if (it.url) {
        html += '<a class="oc-l3-flyout__item" href="' + attrEscape(it.url) + '">'
          + '<span class="oc-l3-flyout__label">' + attrEscape(it.label) + '</span></a>';
      } else {
        html += '<button type="button" class="oc-l3-flyout__item"'
          + ' data-l3="' + attrEscape(it.value) + '" data-l2="' + attrEscape(key) + '">'
          + '<span class="oc-l3-flyout__label">' + attrEscape(it.label) + '</span>'
          + '<span class="oc-l3-flyout__count">' + attrEscape(it.count) + '</span>'
          + '</button>';
      }
    });
    f.innerHTML = html;
  }

  function parseL3(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var items = [], seen = {};
    doc.querySelectorAll('input[name="' + L3_PARAM + '"]').forEach(function (inp) {
      if (seen[inp.value]) return;
      seen[inp.value] = 1;
      var label = inp.value, count = '';
      var lbl = inp.closest('label');
      if (lbl) {
        var t = lbl.querySelector('.facet-checkbox__text-label');
        if (t) label = t.textContent.trim();
        var ct = lbl.querySelector('.facet-checkbox__text');
        if (ct) { var m = ct.textContent.match(/\((\d+)\)/); if (m) count = m[1]; }
      }
      items.push({ value: inp.value, label: label, count: count });
    });
    return items;
  }

  function fetchL3(l2) {
    if (cache[l2]) { renderItems(l2, cache[l2]); return; }
    var f = ensureFlyout();
    f.innerHTML = '<div class="oc-l3-flyout__loading">Loading…</div>';
    fetch(buildPreviewUrl(l2), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { cache[l2] = parseL3(html); renderItems(l2, cache[l2]); })
      .catch(function () {
        if (currentL2 === l2 && flyout) flyout.innerHTML = '<div class="oc-l3-flyout__loading">—</div>';
      });
  }

  /* 訪問時プリフェッチ：その画面の全 L2 を裏で先読み（メモリキャッシュ）→ホバー即時。
     idle ＋ 同時3本に制限。L2↔L3 はコレクション依存なので localStorage には残さない。 */
  function collectL2Values() {
    var scope = document.getElementById('FacetsWrapperDesktop');
    if (!scope) return [];
    var vals = [];
    scope.querySelectorAll('details[id^="Details-' + L2_PARAM + '-"] input[name="' + L2_PARAM + '"]').forEach(function (i) {
      if (vals.indexOf(i.value) === -1) vals.push(i.value);
    });
    return vals;
  }

  function prefetchAll() {
    if (!isDesktop()) return false;
    var vals = collectL2Values();
    if (!vals.length) return false;
    var i = 0, active = 0, MAX = 3;
    function pump() {
      while (active < MAX && i < vals.length) {
        var v = vals[i++];
        if (cache[v]) continue;
        active++;
        fetch(buildPreviewUrl(v), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then((function (val) { return function (html) { cache[val] = parseL3(html); }; })(v))
          .catch(function () {})
          .then(function () { active--; pump(); });
      }
    }
    pump();
    return true;
  }

  function schedulePrefetch() {
    var tries = 0;
    function attempt() {
      if (prefetchAll()) return;                   // L2 が出揃ったら開始
      if (++tries < 20) setTimeout(attempt, 500);  // shop ページのフィルタ注入待ち
    }
    if ('requestIdleCallback' in window) requestIdleCallback(attempt, { timeout: 2000 });
    else setTimeout(attempt, 300);
  }

  /* --- カテゴリページ(facets-fallback のカテゴリリンク)の hover → 子カテゴリ ---
     L2↔L3 は静的 taxonomy（assets/oc-category-tree.json）から引く。クリックで L3 コレクションへ遷移。 */
  var tree = null;
  function loadTree(cb) {
    if (tree) { cb(tree); return; }
    var url = window.OC_CATEGORY_TREE_URL;
    if (!url) { cb(null); return; }
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (j) { tree = (j && j.byKey) || {}; cb(tree); })
      .catch(function () { tree = {}; cb(tree); });
  }

  function handleFromHref(href) {
    if (!href) return '';
    var m = href.match(/\/collections\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function treeEntryForLink(tr, link) {
    if (!tr) return null;
    var h = handleFromHref(link.getAttribute('href'));
    // 2026-10-27：SALE の中分類（sale-l2-*）は表示名で通常カテゴリに当てはめない（細分類の行き先がセール外になるため）
    if (h.indexOf('sale-l2-') === 0) return null;
    var entry = h && tr[h];
    if (!entry) {
      var lbl = (link.querySelector('.facets-fallback__link-title') || link).textContent.trim();
      entry = tr['label:' + lbl];
    }
    if (entry && entry.children && entry.children.length) return entry;
    return null;
  }

  function onFallbackEnter(link) {
    if (!isDesktop()) return;
    loadTree(function (tr) {
      var entry = treeEntryForLink(tr, link);
      if (!entry) return;
      clearTimeout(hideTimer);
      currentL2 = 'cat:' + (handleFromHref(link.getAttribute('href')) || entry.label);
      var items = entry.children.map(function (c) {
        return { label: c.label, url: '/collections/' + c.handle };
      });
      var f = ensureFlyout();
      f.hidden = false;
      positionFlyout(link.closest('.facets-fallback__item') || link);
      renderItems(currentL2, items, true);
    });
  }

  function markFallbackArrows() {
    loadTree(function (tr) {
      if (!tr) return;
      document.querySelectorAll('.facets-fallback__link').forEach(function (link) {
        if (treeEntryForLink(tr, link)) link.classList.add('oc-has-children');
      });
    });
  }

  function onL2Enter(li) {
    if (!isDesktop()) return;
    var input = li.querySelector('input[name="' + L2_PARAM + '"]');
    if (!input) return;
    var l2 = input.value;
    clearTimeout(hideTimer);
    var f = ensureFlyout();
    if (currentL2 === l2 && !f.hidden) { positionFlyout(li); return; }
    currentL2 = l2;
    f.hidden = false;
    positionFlyout(li);
    fetchL3(l2);
  }

  function applyL3(l2, l3) {
    var scope = document.getElementById('FacetsWrapperDesktop') || document;
    var l2box = scope.querySelector('input[name="' + L2_PARAM + '"][value="' + cssEscapeVal(l2) + '"]');
    var l3box = scope.querySelector('input[name="' + L3_PARAM + '"][value="' + cssEscapeVal(l3) + '"]');
    if (l3box) {
      if (l2box && !l2box.checked) l2box.checked = true;
      if (!l3box.checked) l3box.checked = true;
      // Dawn facets.js は 'input'／shop 独自AJAX は 'change' を購読＝両方発火
      l3box.dispatchEvent(new Event('input', { bubbles: true }));
      l3box.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var url = buildPreviewUrl(l2) + '&' + encodeURIComponent(L3_PARAM) + '=' + encodeURIComponent(l3);
      window.location.href = url;
    }
    if (flyout) { flyout.hidden = true; currentL2 = null; }
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    var li = e.target.closest(L2_SEL);
    if (li) { onL2Enter(li); return; }
    var fl = e.target.closest('.facets-fallback__link');
    if (fl) onFallbackEnter(fl);
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var origin = e.target.closest(L2_SEL) || e.target.closest('.facets-fallback__link');
    if (!origin) return;
    var to = e.relatedTarget;
    if (to && flyout && (to === flyout || flyout.contains(to))) return;
    if (to && origin.contains(to)) return;
    scheduleHide();
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('.oc-l3-flyout__item');
    if (!btn) return;
    if (btn.tagName === 'A') return; // カテゴリ系リンクは通常遷移に任せる
    e.preventDefault();
    applyL3(btn.getAttribute('data-l2'), btn.getAttribute('data-l3'));
  });

  window.addEventListener('scroll', function () {
    if (flyout && !flyout.hidden) { flyout.hidden = true; currentL2 = null; }
  }, { passive: true });

  /* ===== モバイル(<990px): フィルタドロワー内の L2 をタップで L3 をインライン展開 =====
     デスクトップは右フライアウト（ホバー）だが、モバイルにはホバーが無く導線ゼロだった。
     各 L2 行に開閉トグル（›）を足し、タップで L3 を AJAX 取得（既存 cache 流用）して
     行の下にインライン表示。L3 はリンク＝タップで L2+L3 フィルタ URL へ遷移（確実）。 */
  var MOBILE_L2_DETAILS = '#FacetsWrapperMobile details[id^="Details-Mobile-' + L2_PARAM + '-"]';

  function mobileL2Value(li) {
    var input = li && li.querySelector('input[name="' + L2_PARAM + '"]');
    return input ? input.value : '';
  }

  function renderMobileL3(panel, l2, items) {
    if (!items || !items.length) {
      panel.innerHTML = '<div class="oc-l3-mobile__empty">—</div>';
      return;
    }
    var html = '';
    items.forEach(function (it) {
      var href = buildPreviewUrl(l2) + '&' + encodeURIComponent(L3_PARAM) + '=' + encodeURIComponent(it.value);
      html += '<a class="oc-l3-mobile__item" href="' + attrEscape(href) + '">'
        + '<span class="oc-l3-mobile__label">' + attrEscape(it.label) + '</span>'
        + '<span class="oc-l3-mobile__count">' + attrEscape(it.count) + '</span></a>';
    });
    panel.innerHTML = html;
  }

  function toggleMobileL3(li, btn) {
    var l2 = mobileL2Value(li);
    if (!l2) return;
    var panel = li.querySelector('.oc-l3-mobile');
    if (panel) {
      var willOpen = panel.hasAttribute('hidden');
      if (willOpen) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }
    panel = document.createElement('div');
    panel.className = 'oc-l3-mobile';
    panel.innerHTML = '<div class="oc-l3-mobile__empty">Loading…</div>';
    li.appendChild(panel);
    btn.setAttribute('aria-expanded', 'true');
    if (cache[l2]) { renderMobileL3(panel, l2, cache[l2]); return; }
    fetch(buildPreviewUrl(l2), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { cache[l2] = parseL3(html); renderMobileL3(panel, l2, cache[l2]); })
      .catch(function () { panel.innerHTML = '<div class="oc-l3-mobile__empty">—</div>'; });
  }

  function enhanceMobileL2() {
    if (isDesktop()) return;
    document.querySelectorAll(MOBILE_L2_DETAILS + ' .mobile-facets__item').forEach(function (li) {
      if (li.querySelector('.oc-l3-mtoggle')) return;                 // 付与済み
      if (!li.querySelector('input[name="' + L2_PARAM + '"]')) return; // L2 チェック無し=対象外
      li.classList.add('oc-l2-has-l3');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'oc-l3-mtoggle';
      btn.setAttribute('aria-label', 'Show subcategories');
      btn.setAttribute('aria-expanded', 'false');
      li.appendChild(btn);
    });
  }

  var mobObserver = null;
  function observeMobileFacets() {
    if (mobObserver) return;
    var wrap = document.querySelector('.mobile-facets__wrapper');
    if (!wrap) return;
    var t = null;
    mobObserver = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(enhanceMobileL2, 120);  // Dawn の facet 再描画後に付け直す
    });
    mobObserver.observe(wrap, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var t = e.target.closest('.oc-l3-mtoggle');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();          // L2 チェックボックスのトグルを防ぐ
    toggleMobileL3(t.closest('.mobile-facets__item'), t);
  });

  /* モバイル(<990px): facets-fallback のカテゴリリンク(子持ち)をタップで L3 をインライン展開。
     5000件超コレクション等で出る「女裝 › 上衣」系のカテゴリナビが対象（desktop はホバー flyout のまま）。
     子カテゴリは静的 taxonomy（oc-category-tree.json）から。展開内はリンク＝タップで L3 コレクションへ。 */
  function renderFallbackL3Mobile(item, link, entry) {
    var panel = document.createElement('div');
    panel.className = 'oc-l3-mobile';
    var html = '<a class="oc-l3-mobile__item oc-l3-mobile__item--all" href="'
      + attrEscape(link.getAttribute('href') || '#')
      + '"><span class="oc-l3-mobile__label">View all</span></a>';
    entry.children.forEach(function (c) {
      html += '<a class="oc-l3-mobile__item" href="/collections/' + attrEscape(c.handle) + '">'
        + '<span class="oc-l3-mobile__label">' + attrEscape(c.label) + '</span></a>';
    });
    panel.innerHTML = html;
    item.appendChild(panel);
    link.classList.add('oc-fallback-open');
  }

  document.addEventListener('click', function (e) {
    if (isDesktop()) return;
    if (!e.target.closest) return;
    if (e.target.closest('.oc-l3-mobile')) return; // 展開内のリンクは通常遷移
    var link = e.target.closest('.facets-fallback__link');
    if (!link) return;
    var item = link.closest('.facets-fallback__item');
    if (!item) return;
    var existing = item.querySelector('.oc-l3-mobile');
    if (existing) { // 2回目以降＝開閉トグル
      e.preventDefault();
      if (existing.hasAttribute('hidden')) {
        existing.removeAttribute('hidden');
        link.classList.add('oc-fallback-open');
      } else {
        existing.setAttribute('hidden', '');
        link.classList.remove('oc-fallback-open');
      }
      return;
    }
    e.preventDefault(); // 子の有無を判定するまで遷移を保留
    loadTree(function (tr) {
      var entry = treeEntryForLink(tr, link);
      if (entry && entry.children && entry.children.length) {
        renderFallbackL3Mobile(item, link, entry);
      } else {
        window.location.href = link.getAttribute('href'); // 子カテゴリ無し＝通常遷移
      }
    });
  });

  function init() {
    schedulePrefetch();
    markFallbackArrows();
    enhanceMobileL2();
    observeMobileFacets();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    markFallbackArrows();
    enhanceMobileL2();
    observeMobileFacets();
  });
})();
